<template>
  <div class="">

    <h1 v-if="isDetailView" class="text-2xl font-bold mb-4">{{ devicename }}</h1>

    <div v-if="loading" class="text-gray-500">Chargement...</div>
    <div v-else-if="devices.length === 0" class="text-gray-500">Aucun Clevinoo trouvé.</div>

    <ul v-else-if="!isDetailView" class="space-y-3">
      <li
        v-for="device in devices"
        :key="device.id"
        @click="$router.push(`/admin/devices/${device.id}`)"
        class="p-4 bg-white rounded-lg shadow hover:bg-blue-50 transition cursor-pointer"
      >
        <span class="text-blue-600 hover:underline text-lg font-medium">
          {{ device.id }} - {{ device.betatest }}
        </span>
      </li>
    </ul>

    <p v-if="error" class="mt-4 text-red-600 font-medium">{{ error }}</p>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      devices: [],
      loading: true,
      error: null,
    }
  },
  computed: {
    isDetailView() {
      // Tu regardes si l’URL actuelle contient un paramètre deviceId
      return !!this.$route.params.deviceId;
    },
    devicename() {
      const deviceId = this.$route.params.deviceId;
      const device = this.devices.find(d => String(d.id) === deviceId);
      return device ? device.betatest : 'Nom inconnu';
    }
  },
  async mounted() {
    try {
      const res = await fetch(`${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/alldevices?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}`, {headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }});
      if (!res.ok) throw new Error('Erreur lors du chargement')
      const data = await res.json()
      this.devices = data
    } catch (err) {
      this.error = err.message || 'Erreur inconnue'
    } finally {
      this.loading = false
    }


  }
}
</script>
